import { render, staticRenderFns } from "./Erosion.vue?vue&type=template&id=8965b386"
import script from "./Erosion.vue?vue&type=script&lang=js"
export * from "./Erosion.vue?vue&type=script&lang=js"
import style0 from "./Erosion.vue?vue&type=style&index=0&id=8965b386&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports